/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
  props: ['left']
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cvv-help", class: { left: _vm.left } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var __vue_staticRenderFns__ = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex" }, [
      _c("div", [
        _vm._v("Visa, Master e outros: 3 dígitos no verso do cartão"),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", { attrs: { src: "/static/images/cvv-help-1.svg?v=1" } }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex" }, [
      _c("div", [_vm._v("American Express: 4 dígitos na frente do cartão")]),
      _vm._v(" "),
      _c("div", [
        _c("img", { attrs: { src: "/static/images/cvv-help-2.svg?v=1" } }),
      ]),
    ])
  },
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4a6875f2_0", { source: "@media screen and (min-width: 992px) {\n.cvv-help {\n    position: absolute;\n    background: rgba(0, 0, 0, 0.8);\n    z-index: 1;\n    color: white;\n    left: 100%;\n    top: -16px;\n    border-radius: 6px;\n    width: 290px;\n    padding: 4px;\n}\n.cvv-help > div {\n    padding: 4px 8px;\n}\n.cvv-help > div img {\n    margin-left: 8px;\n}\n.cvv-help hr {\n    display: none;\n}\n.cvv-help::before {\n    content: \"\";\n    border: 8px solid transparent;\n    border-right-color: rgba(0, 0, 0, 0.8);\n    position: absolute;\n    left: -16px;\n    top: 16px;\n}\n.cvv-help.left {\n    right: 100%;\n    left: unset;\n}\n.cvv-help.left::before {\n    left: unset;\n    right: -16px;\n    border-right-color: transparent;\n    border-left-color: rgba(0, 0, 0, 0.8);\n}\n}\n@media screen and (max-width: 991px) {\n.cvv-help {\n    background: rgba(0, 0, 0, 0.05);\n    padding: 4px 8px;\n    color: rgba(0, 0, 0, 0.6);\n}\n.cvv-help hr {\n    margin: 0;\n}\n.cvv-help > div {\n    padding: 8px;\n}\n.cvv-help > div img {\n    margin-left: 8px;\n}\n}\n\n/*# sourceMappingURL=cvv-help.vue.map */", map: {"version":3,"sources":["frontend/components/cvv-help.vue","cvv-help.vue"],"names":[],"mappings":"AAuBA;AAFA;IAGA,kBAAA;IACA,8BAAA;IACA,UAAA;IACA,YAAA;IACA,UAAA;IACA,UAAA;IACA,kBAAA;IACA,YAAA;IACA,YAAA;ACrBE;ADuBF;IACA,gBAAA;ACrBE;ADuBF;IACA,gBAAA;ACrBE;ADyBF;IACA,aAAA;ACvBE;AD0BF;IACA,WAAA;IACA,6BAAA;IACA,sCAAA;IACA,kBAAA;IACA,WAAA;IACA,SAAA;ACxBE;AD2BF;IACA,WAAA;IACA,WAAA;ACzBE;AD2BF;IACA,WAAA;IACA,YAAA;IACA,+BAAA;IACA,qCAAA;ACzBE;AACF;AD8BA;AAhDA;IAiDA,+BAAA;IACA,gBAAA;IACA,yBAAA;AC3BE;AD6BF;IACA,SAAA;AC3BE;AD8BF;IACA,YAAA;AC5BE;AD8BF;IACA,gBAAA;AC5BE;AACF;;AAEA,uCAAuC","file":"cvv-help.vue","sourcesContent":["<template>\n  <div class=\"cvv-help\" :class=\"{ left: left }\">\n    <div class=\"d-flex\">\n      <div>Visa, Master e outros: 3 dígitos no verso do cartão</div>\n      <div><img src=\"/static/images/cvv-help-1.svg?v=1\" /></div>\n    </div>\n    <hr />\n    <div class=\"d-flex\">\n      <div>American Express: 4 dígitos na frente do cartão</div>\n      <div><img src=\"/static/images/cvv-help-2.svg?v=1\" /></div>\n    </div>\n  </div>\n</template>\n\n<script>\nexport default {\n  props: ['left']\n}\n</script>\n\n<style lang=\"scss\">\n.cvv-help {\n  // desktop\n  @media screen and (min-width: 992px) {\n    position: absolute;\n    background: rgba(0,0,0,.8);\n    z-index: 1;\n    color: white;\n    left: 100%;\n    top: -16px;\n    border-radius: 6px;\n    width: 290px;\n    padding: 4px;\n\n    & > div {\n      padding: 4px 8px;\n\n      img {\n        margin-left: 8px;\n      }\n    }\n\n    hr {\n      display: none;\n    }\n\n    &::before {\n      content: \"\";\n      border: 8px solid transparent;\n      border-right-color: rgba(0,0,0,.8);\n      position: absolute;\n      left: -16px;\n      top: 16px;\n    }\n\n    &.left {\n      right: 100%;\n      left: unset;\n\n      &::before {\n        left: unset;\n        right: -16px;\n        border-right-color: transparent;\n        border-left-color: rgba(0,0,0,.8);\n      }\n    }\n  }\n\n  // mobile\n  @media screen and (max-width: 991px) {\n    background: rgba(0, 0, 0, 0.05);\n    padding: 4px 8px;\n    color: rgba(0, 0, 0, 0.6);\n    \n    hr {\n      margin: 0;\n    }\n\n    & > div {\n      padding: 8px;\n\n      img {\n        margin-left: 8px;\n      }\n    }\n  }\n}\n</style>","@media screen and (min-width: 992px) {\n  .cvv-help {\n    position: absolute;\n    background: rgba(0, 0, 0, 0.8);\n    z-index: 1;\n    color: white;\n    left: 100%;\n    top: -16px;\n    border-radius: 6px;\n    width: 290px;\n    padding: 4px;\n  }\n  .cvv-help > div {\n    padding: 4px 8px;\n  }\n  .cvv-help > div img {\n    margin-left: 8px;\n  }\n  .cvv-help hr {\n    display: none;\n  }\n  .cvv-help::before {\n    content: \"\";\n    border: 8px solid transparent;\n    border-right-color: rgba(0, 0, 0, 0.8);\n    position: absolute;\n    left: -16px;\n    top: 16px;\n  }\n  .cvv-help.left {\n    right: 100%;\n    left: unset;\n  }\n  .cvv-help.left::before {\n    left: unset;\n    right: -16px;\n    border-right-color: transparent;\n    border-left-color: rgba(0, 0, 0, 0.8);\n  }\n}\n@media screen and (max-width: 991px) {\n  .cvv-help {\n    background: rgba(0, 0, 0, 0.05);\n    padding: 4px 8px;\n    color: rgba(0, 0, 0, 0.6);\n  }\n  .cvv-help hr {\n    margin: 0;\n  }\n  .cvv-help > div {\n    padding: 8px;\n  }\n  .cvv-help > div img {\n    margin-left: 8px;\n  }\n}\n\n/*# sourceMappingURL=cvv-help.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/cvv-help.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__